<template>
  <el-card v-if="role=='admin'" v-loading="loading" class="box-card">
    <div slot="header">
      <el-button v-if="edit" icon="el-icon-back" @click="handleBack" size="mini"></el-button>
      <span class="card-header" v-if="edit" style="margin-left: 20px;">{{judul_edit}}</span>
      <span class="card-header" v-else style="margin-left: 20px;">{{data.judul}}</span>
      <el-button v-if="!edit" type="primary" icon="el-icon-plus" @click="handleAdd" style="float: right;" size="mini">Tambah</el-button>
    </div>
    

    <el-form v-if="edit" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" hide-required-asterisk label-position="left">
      <el-form-item label="Pertanyaan" prop="pertanyaan">
        <el-input type="textarea" v-model="ruleForm.pertanyaan"></el-input>
      </el-form-item>
      
      <el-form-item label="Jawaban 1" prop="jawaban1">
        <el-input type="text" v-model="ruleForm.jawaban1"></el-input>
      </el-form-item>

      <el-form-item label="Jawaban 2" prop="jawaban2">
        <el-input v-model="ruleForm.jawaban2"></el-input>
      </el-form-item>

      <el-form-item label="Jawaban 3" prop="jawaban3">
        <el-input v-model="ruleForm.jawaban3"></el-input>
      </el-form-item>

      <el-form-item label="Jawaban 4" prop="jawaban4">
        <el-input v-model="ruleForm.jawaban4"></el-input>
      </el-form-item>

      <el-form-item label="Jawaban 5" prop="jawaban5">
        <el-input v-model="ruleForm.jawaban5"></el-input>
      </el-form-item>


      <el-form-item label="Jawaban benar" prop="jawaban_benar">
        <el-select v-model="ruleForm.jawaban_benar" placeholder="Pilih jawaban benar">
          <el-option label="Jawaban 1" value="jawaban1"></el-option>
          <el-option label="Jawaban 2" value="jawaban2"></el-option>
          <el-option label="Jawaban 3" value="jawaban3"></el-option>
          <el-option label="Jawaban 4" value="jawaban4"></el-option>
          <el-option label="Jawaban 5" value="jawaban5"></el-option>

        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">Simpan</el-button>
      </el-form-item>
    </el-form>

    <div v-else>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="Waktu pengerjaan">
          <el-input type="number" v-model="formInline.waktu_pengerjaan" placeholder="Waktu pengerjaan"></el-input>
        </el-form-item>
        <el-form-item label="Pesan">
          <el-input v-model="formInline.pesan" placeholder="Pesan"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="updateWaktu">Simpan</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="pertanyaan"
          label="Pertanyaan"
          width="200">
        </el-table-column>
        <el-table-column
          prop="jawaban1"
          label="jawaban1"
          width="200">
        </el-table-column>
        <el-table-column
          prop="jawaban2"
          label="Jawaban2"
          width="200">
        </el-table-column>
        <el-table-column
          prop="jawaban3"
          label="Jawaban3"
          width="200">
        </el-table-column>
        <el-table-column
          prop="jawaban4"
          label="Jawaban4"
          width="200">
        </el-table-column>
        <el-table-column
          prop="jawaban5"
          label="Jawaban5"
          width="200">
        </el-table-column>
        <el-table-column
          prop="jawaban_benar"
          label="Jawaban Benar"
          width="120">
        </el-table-column>

        <el-table-column
          fixed="right"
          label="Operations"
          width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">Edit</el-button>
            <el-button @click="handleDelete(scope.row)" type="text" size="small">Hapus</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  
  </el-card>
  <el-card v-else v-loading="loading" class="box-card">
    <div slot="header">
      <span class="card-header" style="margin-left: 20px;">{{data.judul}}</span>
    </div>
    <div v-if="pengguna==null" style="text-align: center;">
      <p>Anda belum pernah melakukan evaluasi sebelumnya, untuk memulai evaluasi silahkan tekan tombol "Mulai Evaluasi"</p>
    </div>
    <div v-else style="text-align: center;" >
      <p>Anda telah melakukan evaluasi sebelumnya, </p>
      <p><b>{{pengguna.jumlah_benar}}</b> dari <b>{{pengguna.jumlah_soal}}</b> jawaban benar, nilai anda <b>{{nilai}}</b></p>
      <p v-if="nilai > 89">predikat anda <b>SANGAT BAIK</b></p>
      <p v-else-if="nilai > 79">predikat anda <b>BAIK</b></p>
      <p v-else-if="nilai > 69">predikat anda <b>CUKUP</b></p>
      <p v-else>predikat anda <b>KURANG</b></p>

      <p>{{data.pesan}}</p>
      <p>Untuk mengulang evaluasi silahkan tekan tombol "Mulai Evaluasi" </p>
    </div>
    <div style="text-align: center;">
      <p>Evaluasi akan dilakukan dengan ketentuan: </p>
      <table style="margin-left: auto; margin-right: auto; text-align: left; padding-bottom: 10px;">
        <tr>
          <td>Jumlah soal</td>
          <td>: {{tableData.length}} soal</td>
        </tr>
        <tr>
          <td>Waktu pengerjaan</td>
          <td>: {{data.waktu_pengerjaan}} menit</td>
        </tr>
      </table>
      <el-button @click="mulaiEvaluasi">Mulai Evaluasi</el-button>
      <el-button v-if="nilai > 79" @click="lihatKunciJawaban">Lihat Kunci Jawaban</el-button>
    </div>
  </el-card>
</template>

<script>
import { database } from '../firebase'

export default {
  data() {
    return {
      edit: false,
      data: {
        judul: 'memuat . . .',
        data: [],
        jumlah_soal: 0,
        waktu_pengerjaan: 0
      },
      role: this.$store.state.user.displayName,
      judul_edit: '',
      ruleForm: {
        pertanyaan: '',
        jawaban1: '',
        jawaban2: '',
        jawaban3: '',
        jawaban4: '',
        jawaban5: '',
        jawaban_benar: '',
      },
      rules: {
        pertanyaan: [
          { required: true, message: 'Masukkan pertanyaan', trigger: 'blur' },
        ],
        jawaban1: [
          { required: true, message: 'Masukkan jawaban', trigger: 'blur' },
        ],
        jawaban2: [
          { required: true, message: 'Masukkan jawaban', trigger: 'blur' },
        ],
        jawaban3: [
          { required: true, message: 'Masukkan jawaban', trigger: 'blur' },
        ],
        jawaban4: [
          { required: true, message: 'Masukkan jawaban', trigger: 'blur' },
        ],
        jawaban5: [
          { required: true, message: 'Masukkan jawaban', trigger: 'blur' },
        ],
        jawaban_benar: [
          { required: true, message: 'Pilih jawaban benar', trigger: 'change' }
        ],
      },
      loading: false,
      tableData: [],
      id: '',
      pengguna: '',
      nilai: 0,
      formInline: {
        waktu_pengerjaan: 0,
        pesan: ''
      }
    }
  },
  methods: {
    updateWaktu: function () {
      var update = {}
      update['isi/'+this.halaman+'/waktu_pengerjaan'] = this.formInline.waktu_pengerjaan
      update['isi/'+this.halaman+'/pesan'] = this.formInline.pesan
          
      database.ref().update(update).then(()=>{
        this.loading = false
        this.$notify({
          title: 'Sukses',
          message: 'Pembaruan telah tersimpan',
          type: 'success'
        });
      }).catch((error) => {
        this.loading = false
        this.$notify.error({
          title: 'Error',
          message: error
        });
      })
    },
    handleBack() {
      this.edit = false
    },
    handleAdd() {
      this.edit = true
      this.judul_edit = 'Tambah Soal'
      this.data.jumlah_soal = this.data.jumlah_soal + 1
      this.id = this.data.jumlah_soal
      this.ruleForm = {
        pertanyaan: '',
        jawaban1: '',
        jawaban2: '',
        jawaban3: '',
        jawaban4: '',
        jawaban5: '',
        jawaban_benar: '',
      }
    },
    handleEdit(data) {
      this.edit = true
      this.judul_edit = 'Edit Soal'
      this.id = data.id
      this.ruleForm = {
        pertanyaan: data.pertanyaan,
        jawaban1: data.jawaban1,
        jawaban2: data.jawaban2,
        jawaban3: data.jawaban3,
        jawaban4: data.jawaban4,
        jawaban5: data.jawaban5,
        jawaban_benar: data.jawaban_benar,
      }
    },
    handleDelete(data) {
      this.$confirm('Apakah anda yakin akan menghapus?', 'Hapus?', {
        confirmButtonText: 'Hapus',
        cancelButtonText: 'Batal',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let evaluasiRef = database.ref('isi/'+this.halaman+'/data/'+data.id)
        evaluasiRef.remove()
          .then(() => {
            this.loading = false
            this.$notify({
              title: 'Sukses',
              message: 'Soal terhapus',
              type: 'success'
            })
          }).catch((error) => {
            this.loading = false
            this.$notify({
              title: 'Gagal',
              message: 'gagal menghapus ('+error+')',
              type: 'error'
            })
          })
      })
    },
    submitForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var update = {}
          update['isi/'+this.halaman+'/data/'+this.id+'/pertanyaan'] = this.ruleForm.pertanyaan
          update['isi/'+this.halaman+'/data/'+this.id+'/jawaban1'] = this.ruleForm.jawaban1
          update['isi/'+this.halaman+'/data/'+this.id+'/jawaban2'] = this.ruleForm.jawaban2
          update['isi/'+this.halaman+'/data/'+this.id+'/jawaban3'] = this.ruleForm.jawaban3
          update['isi/'+this.halaman+'/data/'+this.id+'/jawaban4'] = this.ruleForm.jawaban4
          update['isi/'+this.halaman+'/data/'+this.id+'/jawaban5'] = this.ruleForm.jawaban5
          update['isi/'+this.halaman+'/data/'+this.id+'/jawaban_benar'] = this.ruleForm.jawaban_benar

          update['isi/'+this.halaman+'/jumlah_soal'] = this.data.jumlah_soal
          
          database.ref().update(update).then(()=>{
            this.loading = false
            this.$notify({
              title: 'Sukses',
              message: 'Pembaruan telah tersimpan',
              type: 'success'
            });
            this.handleBack()
          }).catch((error) => {
            this.loading = false
            this.$notify.error({
              title: 'Error',
              message: error
            });
          })
        } else {
          this.loading = false
        }
      });
    },
    mulaiEvaluasi() {
      this.$store.commit('setLagiNgerjain', {lagiNgerjain: true, lagiNgerjainHalaman: this.halaman})
      this.$router.push({name: 'evaluasi-user', params: {halaman: this.halaman}})
    },
    lihatKunciJawaban: function () {
      var listKunciJawaban = ''

      for( var i in this.tableData ){
        listKunciJawaban = listKunciJawaban + '<li>' + this.tableData[i][this.tableData[i]['jawaban_benar']] + '</li>'
      }

      this.$alert(`<ol>`
        + listKunciJawaban +
        `</ol>`, 'Kunci Jawaban', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: 'OK',
      });
    }
  },
  props: {
    halaman: String
  },
  mounted() {
    let evaluasiRef = database.ref('isi/'+this.halaman) 
    evaluasiRef.on('value', (snapshot) => {
      this.data = snapshot.val()
      
      this.tableData = []  
      for (var i in this.data.data) {
        this.tableData.push({
          id: i,
          pertanyaan: this.data.data[i]['pertanyaan'],
          jawaban1: this.data.data[i]['jawaban1'],
          jawaban2: this.data.data[i]['jawaban2'],
          jawaban3: this.data.data[i]['jawaban3'],
          jawaban4: this.data.data[i]['jawaban4'],
          jawaban5: this.data.data[i]['jawaban5'],
          jawaban_benar: this.data.data[i]['jawaban_benar'],
        })
      }
      this.formInline.waktu_pengerjaan = this.data.waktu_pengerjaan
      this.formInline.pesan = this.data.pesan
    })

    if (this.role != 'admin') {
      let penggunaRef = database.ref('pengguna/'+this.$store.state.user.uid+'/evaluasi/'+this.halaman)
      penggunaRef.on('value', (snapshot) => {
        this.pengguna = snapshot.val()
        this.nilai = Math.floor(this.pengguna.jumlah_benar/this.pengguna.jumlah_soal*100)
      })
    }
  }
}
</script>